import { SearchBar, PipelineReports, MultipleToggableDropdown, STATUS_TYPES, Notification } from "dyl-components";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Form, Grid } from "semantic-ui-react";
import pipelineActions from "actions/pipeline";
import contactsActions from "actions/contacts";
import customerPipelineActions from "actions/customer_pipeline"
const MODULE_OPTIONS = [
  { key: "lead", value: "lead", text: "Lead" },
  { key: "opportunity", value: "opportunity", text: "Opportunity" },
  { key: "customer", value: "customer", text: "Customer" },
];

const getDefaultSelectedOwners = (options, userId, isSettings) => {
  if (isSettings || !options?.length) {
    return [];
  }

  const loggedInOption = options.find(
    (owner) => owner.value === Number(userId),
  );
  console.log("loggedInOption",loggedInOption,options,userId)
  if (loggedInOption) {
    return [
      {
        value: loggedInOption.value,
        name: loggedInOption.text,
      },
    ];
  }

  if (options.length === 1 && options[0].value === 0) {
    return [
      {
        value: 0,
        name: options[0].text,
      },
    ];
  }

  return [
    {
      value: options[0].value,
      name: options[0].text,
    },
  ];
};

const PipelineReportsPage = () => {
  const [params, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const searchQuery = params.get("search") || "";
  const pipelineId = params.get("pipeline_id") || null;
  const module = params.get("module") || "lead";

  const isSettings = pathname.split("/")[1] === "settings";

  const user = useSelector((state) => state.auth);

  const {
    categories,
    isReadingCategories,
    pipeline_reports,
    isReadingPipelineReports,
    isUpdatingNewTransitioningPipeline,
  } = useSelector((state) => state.pipeline);

  const { assigned_owners = [], isReadingOwnersAndCoowners } = useSelector(
    (state) => state.contact,
  );

  const [selectedModule, setSelectedModule] = useState(module);
  const [selectedPipeline, setSelectedPipeline] = useState(pipelineId);
  const [selectedOwners, setSelectedOwners] = useState(null);
  const [search, setSearch] = useState("");

  const pipelineCategories = useMemo(() => {
    if (!categories) return [];
    return categories?.filter((category) => category.account_stage === module)?.map((category) => ({
        key: String(category.id),
        value: String(category.id),
        text: category.name,
        stages:
          category.stages?.map((stage) => ({
            key: stage.id,
            value: stage.id,
            text: stage.name,
          sequence_id: stage.sequence_id
          })) || [],
      }));
  }, [categories, module]);

  const stages = useMemo(() => {
    if (!selectedPipeline) {
      return [];
    }

    return (
      pipelineCategories.find((category) => category.value === selectedPipeline)
        ?.stages || []
    );
  }, [selectedPipeline, pipelineCategories]);

  const nestedOwnerOptions = useMemo(() => {
    return assigned_owners
      .map((owner) => {
        const name =
          `${owner.first_name || ""} ${owner.last_name || ""}`.trim() ||
          owner.username

        return {
          text: name,
          key: owner.id,
          value: Number(owner.id),
          hasOptions: false,
          options: [],
          parent: null,
        };
      })
  }, [assigned_owners]);

  useEffect(() => {
    if (
      isSettings ||
      isReadingOwnersAndCoowners ||
      !nestedOwnerOptions.length
    ) {
      return;
    }

    setSelectedOwners(
      getDefaultSelectedOwners(nestedOwnerOptions, user?.user_id, isSettings),
    );
  }, [
    nestedOwnerOptions,
    user?.user_id,
    isSettings,
    isReadingOwnersAndCoowners,
  ]);

  useEffect(() => {
    if (!selectedModule) return;

    dispatch(
      pipelineActions.getPipelineCategories({
        module: selectedModule,
      })
    );

    !pipelineId && setSelectedPipeline(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModule, dispatch]);

  useEffect(() => {
    dispatch(
      contactsActions.getOwnersAndCoOwners({
        list: "pipeline-reports"
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!selectedPipeline && pipelineCategories.length) {
      setSelectedPipeline(pipelineCategories[0].value);
    }
  }, [pipelineCategories, selectedPipeline]);

  useEffect(() => {
    if (selectedPipeline && nestedOwnerOptions.length > 0 && Array.isArray(selectedOwners)) {
      dispatch(pipelineActions.getPipelineReports(selectedPipeline, {
        user_id: selectedOwners?.map((owner) => owner.value)?.join(","),
        search: searchQuery,
      }))
    }
  }, [selectedPipeline, dispatch, selectedModule, selectedOwners, searchQuery, nestedOwnerOptions])

  const refresh = () => {
    dispatch(pipelineActions.getPipelineReports(selectedPipeline, {
      user_id: selectedOwners?.map((owner) => owner.value)?.join(","),
      search: searchQuery,
    }))
  }

  const onSearchSubmit = (value) => {
      const query = new URLSearchParams(params);
    query.set('search', value.trim());
    const query_string = query.toString();
    navigate(`${pathname}${query_string ? `?${query_string}` : ''}`);
  }
  const cancelFunction = () => {
    const query = new URLSearchParams(params);
    query.delete('search');
    const query_string = query.toString();
    navigate(`${pathname}${query_string ? `?${query_string}` : ''}`);
  }
  return (
    <Grid padded verticalAlign="top">
      <Grid.Row columns={2}>
        <Grid.Column width={6}>
          <div className="AccountOpportunity__searchBar">
            <SearchBar
              search={searchQuery}
              searchFcn={onSearchSubmit}
              cancelFcn={cancelFunction}
              placeholder="Search by Contact Name"
            />
          </div>
        </Grid.Column>

        <Grid.Column width={10}>
          <Form>
            <Form.Group style={{ justifyContent: "flex-end" }}>
              <Form.Field
                control={MultipleToggableDropdown}
                values={selectedOwners || []}
                className="CallsByAgent__MultipleToggableDropdown"
                nested_options={nestedOwnerOptions}
                onChange={(_, { value }) => {
                  setSearch("");
                  setSelectedOwners(value);
                }}
                placeholder="Owned By"
                onHoverParent={() => { }}
                searchValue={search}
                onSearchChange={(_, { value }) => setSearch(value)}
                loading={isReadingOwnersAndCoowners}
                isExpandable
                width={9}
              />

              <Form.Select
                placeholder="Select Module"
                options={MODULE_OPTIONS}
                value={selectedModule}
                onChange={(_, { value }) => {
                  setSelectedModule(value);
                  setSelectedPipeline(null);
                  setSearchParams({ module: value });
                }}
                width={3}
              />

              <Form.Select
                placeholder="Select Pipeline"
                options={pipelineCategories}
                value={selectedPipeline}
                onChange={(_, { value }) => {
                  setSelectedPipeline(value);
                  setSearchParams({ module: selectedModule, pipeline_id: value });
                }}
                loading={isReadingCategories}
                disabled={!selectedModule}
                width={4}
              />
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={16}>
          {stages?.length > 0 && (
            <PipelineReports
              stages={stages?.map((stage) => ({
                id: stage.key,
                name: stage.text,
                items: pipeline_reports?.[stage?.text]?.[stage?.key]?.map((contact) => {
                  return {
                    id: contact?.person_id,
                    name: contact?.first_name + " " + contact?.last_name,
                    pipeline_id: contact?.pipeline_id,
                    account_id: contact?.account_id
                  }
                }) || [],
              }))}
              onDragEnd={async (data) => {
                try {
                  const toStage = stages.find((stage) => Number(stage.key) === Number(data.toStageId))
                  if (selectedModule === "customer") {
                    await dispatch(customerPipelineActions.update(data.item.account_id, {
                      pipeline_stage_id: Number(data.toStageId),
                      person_id: Number(data.item.id),
                      pipeline_id: data.item.pipeline_id,
                      close_reason_notes: "",
                      sequence_id: toStage?.sequence_id || null
                    }, { action: 'transition' }));
                  }
                  else {
                    await dispatch(pipelineActions.newTransition(data.item.pipeline_id, {
                      account_id: data.item.account_id,
                      pipeline_stage_id: Number(data.toStageId),
                      contact_id: Number(data.item.id),
                      sequence_id: toStage?.sequence_id
                    }, { sequence_done: true }))
                  }
                  Notification.alert(`Successfully updated stage!`, STATUS_TYPES.SUCCESS);
                  refresh()
                } catch (e) {
                  console.log(e);
                  Notification.alert(`Failed to update stage`, STATUS_TYPES.ERROR);
                }
              }}
              isLoading={isReadingPipelineReports || isUpdatingNewTransitioningPipeline}
            />
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default PipelineReportsPage;
